import { Collection } from '@nozbe/watermelondb';

import {
    ShoppingListProductModel,
    ShoppingListProductPayload,
} from '../../../../types/ShoppingListProduct';
import { DBWriterLoggerFunction } from '../../../../types/logger';

export const prepareCreateShoppingListProduct = ({
    payload,
    userId,
    organisationID,
    collection,
}: {
    payload: ShoppingListProductPayload;
    userId: string;
    organisationID: string;
    collection: Collection<ShoppingListProductModel>;
}) =>
    collection.prepareCreate((shoppingListProduct) => {
        shoppingListProduct.productId = payload.productId;
        shoppingListProduct.organisationId = organisationID;
        shoppingListProduct.userId = userId;
        shoppingListProduct.quantity = payload.quantity;
        shoppingListProduct.shoppingListId = payload.shoppingListId;
        shoppingListProduct.totalQuantity = payload.totalQuantity;
        shoppingListProduct.unitType = payload.unitType;
        shoppingListProduct.productSalesUnitId = payload.productSalesUnitId;
    });

export const logAddShoppingListProductAction = ({
    shoppingListProduct,
    logDBAction,
    tableName,
}: {
    shoppingListProduct: ShoppingListProductModel;
    logDBAction: DBWriterLoggerFunction;
    tableName: string;
}) => {
    logDBAction({
        message: 'Add shopping list product',
        modelName: tableName,
        payload: shoppingListProduct,
    });
};
